<template>
  <div class="form__group" :class="{ 'has-danger' : hasError }">
    <label :for="name" v-if="label">{{ label }}: <span class="required" v-if="required">*</span></label>
    <date-picker :date="startDate" :option="option" :showActionButtons="showbtn"></date-picker>
    <span class="help is-danger" v-if="hasError">{{ errorMessage }}</span>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker/DatePicker'

export default {
  name: 'dateTimeField',
  props: {
    label: {
      required: false,
      type: String
    },
    value: {
      required: true
    },
    name: {
      required: true,
      type: String
    },
    errorMessage: {
      required: false,
      type: String
    },
    hasError: {
      required: false
    },
    required: {
      type: Boolean
    },
    isRepeatField:{
      type: Boolean
    }
  },
  mounted () {

    let date = new Date().toISOString()
    date = date.replace('T', ' ')
    date = date.substring(0, 16)  

    this.startDate = {
      time: this.value ? this.value : date
    }

    if(this.isRepeatField){
      this.startDate = {
        time: this.value ? this.value : '' 
      }
    }

    this.updateInput()
  },
  data: () => ({
    startDate: {
      time: ''
    },
    option: {
      type: 'min',
      week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      format: `YYYY-MM-DD HH:mm`,
      inputClass: 'form-control',
      color: {
        checked: '#F50057',
        header: '#423799',
        headerText: '#fff'
      },
      buttons: {
        ok: 'Ok',
        cancel: 'Cancel'
      },
      overlayOpacity: 0.5, // 0.5 as default
      dismissible: true // as true as default
    },
    showbtn:true
  }),
  methods: {
    updateInput () {
      var value = ''     
      if(this.isRepeatField){
        this.option.type='day'
        this.option.format= `YYYY-MM-DD`
        this.showbtn=false
          // this.startDate = {
          //   time: this.value ? this.value : date.substring(0, 10) 
          // }
        value = this.startDate.time !== '' ? this.startDate.time : ''
      }else{
        if(this.startDate.time){
          // startDate ~ YYYY-MM-DD HH:mm
          let temp = this.startDate.time.split(" ")
          // ["YYYY-MM-DD", "HH:mm"]
          if(temp.length===2){
            let _date = temp[0].split("-")
            // ["YYYY", "MM", "DD"]
            let _time = temp[1].split(":")
            // ["HH", "mm"]
            if(_date.length===3 && _time.length>=2){
              value = new Date(_date[0], _date[1]-1, _date[2], _time[0], _time[1]).toISOString()   
            }else{
              value = ''
            }
          }else{
            value = ''
          }
        }else{
          value = ''   
        }
          // value = this.startDate.time !== '' ? new Date(this.startDate.time).toISOString() : ''   
      }
      this.$emit('input', value)
    }
  },
  watch: {
    'startDate.time' () {
      this.updateInput()
      return this.startDate.time
    }
  },
  components: {
    DatePicker
  }
}
</script>



// WEBPACK FOOTER //
// DateTimeField.vue?edb860e0